import { BaseToast } from "./BaseToast";
import { ToastProps } from "./types";

export const InfoToast = ({ children, ...rest }: ToastProps) => {
  return (
    <BaseToast {...rest} toastType="info">
      {children}
    </BaseToast>
  );
};
